import { GetDocumentRequest } from '../domain/types';
import { AuthenticationData } from '../store/authentication';
import { apiClient } from './apiClient';

const downloadFile = (blob: Blob, filename: string) => {
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
};

export const getDocument = async (request: GetDocumentRequest) => {
    const blob = await apiClient<Blob>(
        `${request.apiProxyPath}/document/${request.documentType}/${request.languageCode}`,
        {
            method: 'POST',
            body: request.data,
            apiKey: request.apiKey,
            responseType: 'blob',
            sentryTag: 'get_document',
            sentryExtra: { documentType: request.documentType, languageCode: request.languageCode },
        },
    );
    downloadFile(blob, `${request.documentType}_terms.pdf`);
};

export type PpiDocumentType = 'PRODUCT_FACT_SHEET' | 'PRE_AND_POST_PURCHASE' | 'INSURANCE_TERMS' | 'INSURANCE_MEDIATION';

export const getPpiDocument = async (
    apiProxyPath: string,
    apiKey: string,
    applicationReferenceNumber: string,
    ppiDocumentType: PpiDocumentType,
) => {
    const blob = await apiClient<Blob>(
        `${apiProxyPath}/application/${applicationReferenceNumber}/documents/ppi/${ppiDocumentType}`,
        {
            method: 'GET',
            apiKey,
            responseType: 'blob',
            sentryTag: 'get_ppi_document',
            sentryExtra: { arn: applicationReferenceNumber, ppiDocumentType },
        },
    );
    downloadFile(blob, `${ppiDocumentType}.pdf`);
};

export const uploadDocumentService = (
    handleDocumentUrl: string,
    apiKey: string,
    authenticationData: AuthenticationData,
    documentType: string,
    file: File,
): Promise<unknown> => {
    const formData = new FormData();
    formData.append('file', file);

    return apiClient<unknown>(`${handleDocumentUrl}/${documentType}`, {
        method: 'POST',
        body: formData,
        apiKey,
        authenticationData,
        sentryTag: 'upload_document',
        sentryExtra: { documentType, fileName: file.name, fileSize: file.size },
    });
};
